import { render, staticRenderFns } from "./BaseOutlineDangerButton.vue?vue&type=template&id=9552f38a&scoped=true&"
import script from "./BaseOutlineDangerButton.vue?vue&type=script&lang=js&"
export * from "./BaseOutlineDangerButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseOutlineDangerButton.vue?vue&type=style&index=0&id=9552f38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9552f38a",
  null
  
)

export default component.exports